import cloneDeep from 'lodash/cloneDeep'

export const risk_unit_types = [
  { text: '% of Portfolio', value: 1 },
  { text: 'Volatility Adj. Sizing vs S&P 500', value: 2 },
  { text: '% of Portfolio Divided by (ATR x Share Price)', value: 3 },
  { text: 'Normalized ATR Sizing (% of Portfolio / NATR x Share Price)', value: 4 }
]

export const existing_position_buy_actions = [
  { text: 'Do NOT add to existing positions when buy signal matches', value: 1 },
  { text: 'Add at % of Portfolio', value: 2 },
  { text: 'Add at % of Last Buy Value', value: 3 },
  { text: 'Add at % of Initial Buy Value', value: 4 },
  { text: 'Add # of Risk Units', value: 5 }
]

export const fully_invested_actions = [
  { text: 'Sell securities with past __ days performance < __ and held at least __ days',
    value: 9,
    enabled: false,
    ordering: 1,
    percentage: -3,
    trailing_stop_days: 30,
    minimum_held_days: 90,
    vs_sp_enabled: false,
    vs_sp_threshold: 5,
    vs_sp_significance: 2 },
  { text: 'Sell securities with trailing ATR price decline and stock  optionally up at least __%',
    value: 10,
    enabled: false,
    ordering: 1,
    percentage: 1,
    trailing_stop_days: 30,
    minimum_held_days: 90,
    stock_up_enabled: false,
    stock_up_at_least: 1,
    vs_sp_enabled: false,
    vs_sp_threshold: 5,
    vs_sp_significance: 2 },
  { text: 'Sell securities with trailing ATR price decline and stock optionally down at least __%',
    value: 11,
    enabled: false,
    ordering: 1,
    percentage: 1,
    trailing_stop_days: 30,
    minimum_held_days: 90,
    stock_down_enabled: false,
    stock_down_at_least: 1,
    vs_sp_enabled: false,
    vs_sp_threshold: 5,
    vs_sp_significance: 2 },
  { text: 'Acquire using all remaining cash (min 1 share)', value: 1, enabled: false, ordering: 1, percentage: 0 },
  { text: 'First in First Out (FIFO) Sell to Acquire Funds', value: 2, enabled: false, ordering: 1, percentage: 0 },
  { text: 'Sell underperforming holdings to acquire funds (all-time perf)', value: 3, enabled: false, ordering: 1, percentage: 0 },
  { text: 'Sell underperforming holdings to acquire funds (avg daily perf)', value: 4, enabled: false, ordering: 1, percentage: 0 },
  { text: 'Sell out-performing issues provided they are up at least __%',
    value: 5,
    enabled: false,
    ordering: 1,
    percentage: 0,
    vs_sp_enabled: false,
    vs_sp_threshold: 5,
    vs_sp_significance: 2 },
  { text: 'Sell underperforming issues provided they are down at least __%',
    value: 6,
    enabled: false,
    ordering: 1,
    percentage: 0,
    vs_sp_enabled: false,
    vs_sp_threshold: 5,
    vs_sp_significance: 2 },
  { text: 'Sell securities at an __ day low', value: 7, enabled: false,
  ordering: 1, percentage: 0, exit_time_period_id: null,
  has_outperformed: false, has_underperformed: false },
  { text: 'Sell securities at an __ day high', value: 8, enabled: false,
  ordering: 1, percentage: 0, exit_time_period_id: null,
  has_outperformed: false, has_underperformed: false },
  { text: 'Sell securities when current __ day high is greater than __ day high at purchase plus __ ATRs', value: 12, enabled: false,
  ordering: 1, percentage: 0, exit_time_period_id: null, has_outperformed: false, has_underperformed: false, atr:1 }

]

export const volatility_time_periods = [
  { text: '1 week', value: 1 },
  { text: '2 weeks', value: 2 },
  { text: '3 weeks', value: 3 },
  { text: '4 weeks', value: 4 },
  { text: '1 Month', value: 4 }
]
export const volatility_sizing = [
  { text: 'More volatile positions are sized smaller (SPY Volatility / Stock Volatility)', value: 1 },
  { text: 'More volatile positions are sized larger (Stock Volatility / SPY Volatility)', value: 2 }

]

export const atr_time_periods = [
  { text: '1 week', value: 1 },
  { text: '2 weeks', value: 2 },
  { text: '3 weeks', value: 3 },
  { text: '4 weeks', value: 4 },
  { text: '90 Days', value: 5 }
]

export const exit_time_periods = [
  { text: '1 week', value: 1 },
  { text: '2 weeks', value: 2 },
  { text: '3 weeks', value: 3 },
  { text: '4 weeks', value: 4 },
  { text: '50 Days', value: 6 },
  { text: '90 Days', value: 5 }
]

export const volume_time_periods = [
  { text: '1 week', value: 1 },
  { text: '2 weeks', value: 2 },
  { text: '3 weeks', value: 3 },
  { text: '4 weeks', value: 4 },
  { text: '90 Days', value: 5 }
]

export const buy_signal_frequencies = [
  { text: 'Check Daily', value: 1 },
  { text: 'Check Once a Week', value: 2 },
  { text: 'Check Once a Month', value: 3 },
  { text: 'Check Quarterly', value: 4 },
  { text: 'Check Semi-Annually', value: 5 },
  { text: 'Check Once a Year', value: 6 }
]

const defaultEntryRule = Object.freeze({
  risk_units: 1,
  risk_unit_type_id: 1,
  existing_position_buy_action_id: 1,
  existing_add_unit: null,
  fully_invested_action_id: 0,
  prevent_holding_with_signal_from_being_sold: false,
  fully_invested_actions: [], // cloneDeep(fully_invested_actions),
  percent_of_portfolio: 7.0,
  volatility_time_period_id: 2,
  volatility_min_ratio: 0.10,
  volatility_max_ratio: 2.0,
  volatility_sizing: 1,
  atr_time_period_id: 2,
  sell_underperforming_up_percentage: null,
  stock_price_to_use: 'closing',
  sma_adjusted_square: false,
  sma_adjusted_days: 200,
  sma_adjusted_enabled: false,
  addv_adjusted_percent: 10,
  addv_adjusted_enabled: false,

})
const defaultExitRule = Object.freeze({
  atr_decline_enabled: true,
  atr_decline: 3,
  stop_loss_exit_enabled: false,
  stop_loss_exit: null,
  stop_atr_gain_exit_enabled: false,
  stop_atr_gain_exit: 2,
  atr_stop_gain_time_period_id: 2,
  stop_gain_exit_enabled: false,
  stop_gain_exit: null,
  stop_gain_exit_realtime: false,
  exit_max_time_enabled: false,
  exit_max_time: null,
  trailing_atr_stop_loss_exit_enabled: false,
  trailing_atr_stop_loss_number: 1,
  trailing_atr_stop_loss_days: 30,
  trailing_atr_stop_loss_time_period_id: 2,
  exit_time_period_low_enabled: false,
  exit_time_period_low_id: 3,
  exit_time_period_high_enabled: false,
  exit_time_period_high_id: 3,
  d13_exit_when_owner_exits: false,
  f13_exit_no_longer_in_group: false,
  minimum_holding_days_enabled: false,
  minimum_holding_days: null,
  stock_price_to_use: 'closing',
  avg_ranking_exit: { enabled: false, direction: 1, number_of_quarters: '8', change_min: '5', ranking_min: null, ranking_max: null, long_short: 'long' }
})

const defaultRiskManagement = Object.freeze({
  max_individual: null,
  max_individual_above_initial: null,
  trim_position_if_over_max: 1,
  max_long: null,
  max_short: null,
  max_industry: null,
  max_sector: null,
  max_market_cap: null,
  signals: [{ signal_id: 1, max_risk: null },
    { signal_id: 2, max_risk: null },
    { signal_id: 3, max_risk: null },
    { signal_id: 4, max_risk: null },
    { signal_id: 6, max_risk: null }
  ],
  rebalancing:{enabled:false, frequency:1, method:2, f13_timing:false}
})

export const marketTiming = Object.freeze({
  enabled: false,
  moving_average: { months: 10, index: 169819, enabled: true },
  index_performance: { percent_increase: 20,
    days: 200,
    index: 169819,
    compare_to: 'price',
    compare_to_ma: '50',
    enabled: false
  },
  percent_of_portfolio_to_cash: 100,
  freeze_new_buys: false,
  require_recession_indicators: true,
  and_or_indicators: 'or',
  recession_indicators: [
    /* {enabled:false, macro_data_type_id: 1, above_below: 'below',threshold:0,description:'Advance Real Retail and Food Services Sales' },
    { enabled:false,macro_data_type_id: 2, above_below: 'below',threshold:0,description:'Industrial Production Index' },
    { enabled:false,macro_data_type_id: 3, above_below: 'below',threshold:0,description:'All Employees, Total Nonfarm/Civilian Labor Force Level' },
    { enabled:false,macro_data_type_id: 4, above_below: 'below',threshold:-10,require_other_macro_data_type_id:5,require_other_enabled:true,description:'Housing Starts' },
    { enabled:false, macro_data_type_id: 5, above_below: 'below',threshold:3,require_other_macro_data_type_id:4,require_other_enabled:true,description:'Real Personal Income' },
    { enabled:false,macro_data_type_id: 6, above_below: 'above',threshold:0,description:'Unemployment Rate Change From Year Ago Seasonally Adjusted' }, */
    { enabled: false, macro_data_type_id: 'insider', above_below: 'above', threshold: 1, description: 'WhaleWisdom Insider Weekly Sell/Buy Ratio' }
  ],
  resume_and_or_indicators: 'or',
  resume_indicators: [
    { enabled: true, id: 1, description: 'When index price goes back above the its defined moving average', above_below: '', threshold: 0 },
    { enabled: true, id: 2, description: 'WhaleWisdom Insider Weekly Sell/Buy Ratio', above_below: 'below', threshold: 1 },
    { enabled: false, id: 3, description: 'Index Price Decline', above_below: 'below', threshold: 20, index: 169819 },
    { enabled: false, id: 4, description: 'Price Appreciation Reversion', threshold: 0 },
  ]
})

const defaultGeneral = Object.freeze({
  start_date: '2017-1-1',
  end_date: null,
  starting_amount: 100000,
  test_system: false,
  trading_cost_per_trade: 0,
  buy_signal_frequency_id: 1,
  short_maintenance_margin: 30,
  slippage_enabled: false,
  slippage_rate: 25,
  signal_ordering: 0, // '', high, low
  comp_index: { id: 169819, description: 'S&P 500 Total Return Index' }
})

const defaultFilters = Object.freeze({
  sectors: [],
  industries: [],
  market_caps: [],
  countries: [],
  etf_filter: 0,
  adr_filter: 0,
  avg_stock_price_min: null,
  avg_stock_price_max: null,
  avg_daily_volume_min: null,
  avg_daily_volume_max: null,
  avg_dollar_vol_liquidity_min: null,
  avg_dollar_vol_liquidity_max: null,
  excluded_stocks: [],
  included_stocks: [],
  limit_new_purchases_days: null,
  minimum_trading_history_days: null,
  natr_min: null,
  natr_max: null,
  within_atr_high_enabled: false,
  within_atr_high: 1,
  within_atr_low_enabled: false,
  within_atr_low: 1,
  volatility_enabled: false,
  volatility_time_period_id: 14,
  volatility_direction: '<',
  volatility_percentage: 10,
  dividend_yield_min: null,
  insider_ownership_min:null,
  insider_ownership_max:null
})

const perf_vs_sp_13f = Object.freeze({
  selected: false,
  max_filers: 10,
  top_performing_type: {
    description: 'Do not select filers based on performance',
    value: 0,
    requires_subscription: true
  },
  turnover_type: {
    description: 'Any',
    value: 0,
    requires_pro_subscription: true
  },
  top10_type: {
    description: 'Any',
    value: 0,
    requires_pro_subscription: true
  },
  holdings_from_to: [5, 1000],
  mc_from_to: [100, 400000],
  use_holdings: true,
  use_quarters: false,
  quarters_min: null,
  quarters_max: null,
  use_mc: true,
  time_held_top10_from_to: [4, 8],
  use_time_held_top10: false,
  adv_insider_ownership: null,
  variance_min: null,
  variance_max: null,
  use_variance: false,
  require_one_year_ws_outperform: false,
  use_sharpe_ranking: false,
  sharpe_ranking_min: null,
  sharpe_ranking_max: null,
  mgr_weight_outperformed_equal:false,
  equal_weight_outperformed_manager:false,
  sc: {
    identifier: 'sector_concentration',
    type: 'dynamic_number_range',
    title: '13F Sector Concentration',
    suffix: '%',
    items: []
  },
  use_market_cap_range: false,
  market_cap_range_min: 40,
  market_cap_range_max: 100,
  market_cap_range: [6, 10],
  rankings:[],
  use_rankings:false,
  weightings:[],
  use_weightings:false
})

class WhaleTraderSignal {
    enabled=false;
    signal_id=-1;
    long_enabled=true;
    short_enabled=false;
    description='';
    name='';
    join_type='or';
    stock_basket=[];
    valid=true;
    number_of_days_to_evaluate=null;
    constructor (enabled) {
      this.enabled = enabled
    }
}

class F13Signal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 1
    this.description = 'Signals taken from quarterly 13F filings'
    this.name = '13F'
  }

    filer_group={ description: '', id: null, filers: [] };
    // use_heat_map_stocks=false
    // use_fund_performance=false
    filer_performance=cloneDeep(perf_vs_sp_13f)
    holdings=10
    stock_selection_type_id=1
    minimum_funds=null
    minimum_percent_portfolio=null
    exclude_if_qoq_decrease=null;
    only_include_if_qoq_increase=null;
    exclude_positions_held_quarters=null;
    exclude_held_less_than=null;
    top_holdings_per_filer=10
    group_evaluation_type_id=1
    max_days_to_wait=5;
    short_signal_stocks_drop_out=true;
    trading_delay=1;
    whalescore= null;
    heat_map= false;
    crowded_stocks=false;
    crowded_stocks_avg_min=0;
    crowded_stocks_held_min=0;
    crowded_stocks_perf_min=0;
    exclude_if_price_jump=null;
    include_if_price_jump=null;
    overweight=false;
    use_original_filings=false;
    include_put_call_ratio_above=null;
    include_put_call_ratio_below=null;
}

class D13Signal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 2
    this.name = '13D/G'
    this.description = 'Signals taken from 13D/G Filing Data'
  }
    filer_group={ description: '', id: null, filers: [] }
    include_13d=true
    include_13g=true
    percent_ownership_threshold='5'
    treat_amended_as_buys=true
    amended_must_increase=false
    treat_below_5_as_short=true
    long_keywords_enabled=false
    short_keywords_enabled=false
    long_keywords=''
    short_keywords=''
    trading_delay=1
    exclude_ownership_over=null
    fund_classifications=[];
    holdings_from_to= [5, 1000]
    aums= []
    adv_aum_from_to= [100, 400000]
    use_holdings= false
    use_adv_aum=false
    allow_empty_13f=true
    minimum_prior_1m_perf=null;
    minimum_prior_6m_perf=null;
    minimum_prior_filings=null;
}

class InsiderSignal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 3
    this.name = 'Insiders'
    this.description = 'Signals taken from insider buying (Form 4) transactions'
  }
    entry_owners= []
    excluded_owners= []
    entry_cluster_buy_criteria= {
      transaction_type: 4,
      date_range: 1,
      owner_types: [5],
      minimum_unique_owners: '3',
      minimum_transaction_amount: '100000',
      minimum_percent_ownership: '',
      exclude_public_offering: true,
      is_10b5: false,
      minimum_transaction_count: '',
      buy_reversal: false,
      restrict_recent_52_week_high: false,
      restrict_recent_52_week_low: false,
      restrict_percent_52_week_high: null,
      restrict_percent_52_low_high: null,
      restrict_percent_52_week_high_to: null,
      restrict_percent_52_low_high_to: null
    }
    trading_delay=1
}

export const defaultBreakoutRule = Object.freeze({
  long_short: 'long',
  allocation: 50,
  up_down: 'up',
  breakout_days: 21,
  increase_in_price: 0,
  must_have_volume: true,
  increase_in_volume: 0,
  volume_time_period_id: 1,
  enabled: true
})

class TrendSignal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 4
    this.name = 'Trends'
    this.description = 'Signals taken from pricing/volume trends'
    this.stock_basket = []
  }
    breakout_rules=[]
    stocks_vs_sp=[]
  moving_average_rules=[]
  avg_ranking_rules=[]
  overbought_rules=[]
    and_all_rules=false
    join_type='filter';
}

class WhaleMlSignal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 5
    this.name = 'WhaleML'
    this.description = 'Signals taken from proprietary WhaleML algos'
  }
    predictions=[
      /* { name: '13F-Based Predictions', enabled: false, whale_ml_type_id: 1, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } },
      { name: '13D/G-Based Predictions', enabled: false, whale_ml_type_id: 2, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } },
      { name: 'Insider-Based Predictions', enabled: false, whale_ml_type_id: 3, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } },
      { name: 'Contrarian Predictions', enabled: false, whale_ml_type_id: 4, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } },
      { name: 'Other Predictions', enabled: false, whale_ml_type_id: 5, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } }, */
      { name: 'Overall Predictions', enabled: false, whale_ml_type_id: 6, long: { min: 1, max: 3 }, short: { min: -1, max: -3 } }
      //  {name: 'Sum of all predictions',enabled:false,whale_ml_type_id:7,long: { enabled:false,min: 1, max: 3 }, short: { enabled:false, min: -1, max: -3 }}
    ]
    use_4_week_moving_average=false
    only_include_if_change_from_prior_week=false
}

class WhaleIndexSignal extends WhaleTraderSignal {
  constructor (enabled) {
    super(enabled)
    this.signal_id = 6
    this.name = 'WhaleIndex'
    this.description = 'Signals taken from the WhaleIndex Portfolio'
  }
    whale_indices=[
      { name: 'WhaleIndex 100', enabled: false, whale_index_id: 2 },
      { name: 'WhaleIndex 30 Omega', enabled: false, whale_index_id: 3 },
      { name: 'WhaleIndex 20 Omega', enabled: false, whale_index_id: 5 },
      { name: 'WhaleIndex 30 Conservative', enabled: false, whale_index_id: 4 },
      { name: 'WhaleIndex 20 Conservative', enabled: false, whale_index_id: 6 },

      { name: 'WhaleIndex Mid/Small/Micro 100', enabled: false, whale_index_id: 7 },
      { name: 'WhaleIndex Mid/Small/Micro 30 Omega', enabled: false, whale_index_id: 8 },
      { name: 'WhaleIndex Mid/Small/Micro 20 Omega', enabled: false, whale_index_id: 10 },
      { name: 'WhaleIndex Mid/Small/Micro 30 Conservative', enabled: false, whale_index_id: 9 },
      { name: 'WhaleIndex Mid/Small/Micro 20 Conservative', enabled: false, whale_index_id: 11 },

      { name: 'Whale OMEGA 50 - $1billion MC or greater', enabled: false, whale_index_id: 13 },
      { name: 'WhaleIndex 2.0 - 100', enabled: false, whale_index_id: 16 },
      { name: 'WhaleIndex 2.0 - 30', enabled: false, whale_index_id: 17 },
      { name: 'WhaleIndex 2.0 - 20', enabled: false, whale_index_id: 18 },
      { name: 'WhaleIndex 2.0 Mid/Small/Micro 100', enabled: false, whale_index_id: 19 },
      { name: 'WhaleIndex 2.0 Mid/Small/Micro 30', enabled: false, whale_index_id: 20 },
      { name: 'WhaleIndex 2.0 Mid/Small/Micro 20', enabled: false, whale_index_id: 21 },
      { name: 'WhaleIndex Healthcare - 100', enabled: false, whale_index_id: 22 },
      { name: 'WhaleIndex Healthcare (minus biotech) - 100', enabled: false, whale_index_id: 23 },
      { name: 'WhaleIndex Information Technology - 100', enabled: false, whale_index_id: 24 },
      { name: 'WhaleIndex Energy/Materials - 100', enabled: false, whale_index_id: 41 },
      { name: 'WhaleIndex 200 - <$2B Market Cap', enabled: false, whale_index_id: 38 }
      /* { name: 'WhaleIndex Industrials - 100', enabled: false, whale_index_id: 25},
      { name: 'WhaleIndex Financials - 100', enabled: false, whale_index_id: 27},
      { name: 'WhaleIndex Communications - 100', enabled: false, whale_index_id: 29}, */
    ]
    trading_delay=2
}

export const defaultWhaleTraderCriteria = Object.freeze({
  signals: {
    f13_signal: new F13Signal(false),
    d13_signal: new D13Signal(false),
    insider_signal: new InsiderSignal(false),
    trend_signal: new TrendSignal(false),
    //  whaleml_signal: new WhaleMlSignal(false),
    whaleindex_signal: new WhaleIndexSignal(false)
  },
  risk_management: cloneDeep(defaultRiskManagement),
  general: cloneDeep(defaultGeneral),
  filters: cloneDeep(defaultFilters),
  market_timing: cloneDeep(marketTiming),
  market_timing_rules: [],
  entry_rules: { long: cloneDeep(defaultEntryRule), short: cloneDeep(defaultEntryRule) },
  exit_rules: { long: cloneDeep(defaultExitRule), short: cloneDeep(defaultExitRule) }

})
